import { useEffect, useState } from 'react';

import authRequest from '../../../../utils/fetch';

import { URL } from './url';

type GithubOrgListResponse = {
	organizations: GH.Organisation[];
};
type GithubOrganisationList = {
	orgList: GH.Organisation[] | null;
	setOrgList: (newOrgList: GH.Organisation[]) => void;
	loading: boolean;
	error: string | null;
};
export const useGithubOrganisationList = (): GithubOrganisationList => {
	const [error, setError] = useState<string | null>(null);
	const [loading, setLoading] = useState<boolean>(true);
	const [orgList, setOrgList] = useState<GH.Organisation[]>([]);

	const getOrgList = async () => {
		const request = authRequest(URL('getOrganizations'), {
			method: 'POST',
			body: JSON.stringify({}),
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
			},
		});

		try {
			const res = await fetch(request);
			if (!res.ok) {
				throw new Error(`http error status ${res.status} with text: ${res.statusText}`);
			}

			const response = (await res.json()) as GithubOrgListResponse;

			setOrgList(response.organizations);
		} catch (e) {
			setError('An error has occurred');
		}

		setLoading(false);
	};

	useEffect(() => {
		getOrgList();
	}, []);

	return {
		orgList,
		setOrgList,
		loading,
		error,
	};
};
